import React, { useEffect } from 'react';
import './Toast.css';

const icons = {
  success: '✔️',
  error: '❌',
  warning: '⚠️',
  info: 'ℹ️',
};

const Toast = ({ type = 'info', message, open, onClose, duration = 3500 }) => {
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  if (!open) return null;
  return (
    <div className={`toast toast-${type}`} role="status" aria-live="polite">
      <span className="toast-icon">{icons[type]}</span>
      <span className="toast-message">{message}</span>
      <button className="toast-close" aria-label="Close notification" onClick={onClose}>&times;</button>
    </div>
  );
};

export default Toast; 